import { createAsyncThunk } from '@reduxjs/toolkit';
import type { UserAuth, UserInfo } from 'src/store/client/slices/userSlice';

import { commonService } from '@/store/server/common/common/common.service';
import { mypageService } from '@/store/server/common/mypage/mypage.service';

const userThunk = {
  myDataLoad: createAsyncThunk<UserInfo>('user/myDataLoad', async () => {
    const response = await mypageService.getUserInfo();
    return response.data.data as UserInfo;
  }),

  refreshTokenNew: createAsyncThunk<UserAuth>('user/refreshTokenNew', async () => {
    const response = await commonService.refreshToken();
    return response;
  }),

  refreshTokenAll: createAsyncThunk<UserAuth>('user/refreshTokenAll', async () => {
    const response = await commonService.refreshToken();
    return response;
  }),
};

export default userThunk;
